// extracted by mini-css-extract-plugin
export default {"item":"ProductSlider_item__83iYN","next":"ProductSlider_next__gVpw2","prev":"ProductSlider_prev__ClDZI","slider":"ProductSlider_slider__gIxYb"};